export function Change(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2126 0.313997C15.7411 -0.0650714 15.0496 -0.0359123 14.6119 0.401475L14.5243 0.49891C14.145 0.970116 14.1742 1.66114 14.6119 2.09853L16.3146 3.8H13.9013L13.6965 3.80652C12.5429 3.88012 11.5116 4.57175 11.01 5.62422L6.37831 15.344L6.3218 15.4435C6.1748 15.6641 5.92569 15.8 5.6555 15.8H1.20085L1.07807 15.8062C0.472535 15.8677 0 16.3787 0 17C0 17.6627 0.53764 18.2 1.20085 18.2H5.6555L5.86026 18.1935C7.01382 18.1199 8.04518 17.4283 8.54671 16.3758L13.1784 6.65606L13.235 6.55647C13.382 6.33587 13.6311 6.2 13.9013 6.2H16.3146L14.6119 7.90147L14.5243 7.99891C14.145 8.47012 14.1742 9.16114 14.6119 9.59853C15.0808 10.0672 15.8412 10.0672 16.3101 9.59853L19.3552 6.55564L19.4722 6.42939C20.213 5.56503 20.174 4.26261 19.3552 3.44437L16.3101 0.401475L16.2126 0.313997Z"
          fill="currentColor"
        />
        <path
          d="M14.6119 12.4015C15.0496 11.9641 15.7411 11.9349 16.2126 12.314L16.3101 12.4015L19.3552 15.4444C20.174 16.2626 20.213 17.565 19.4722 18.4294L19.3552 18.5556L16.3101 21.5985C15.8412 22.0672 15.0808 22.0672 14.6119 21.5985C14.1742 21.1611 14.145 20.4701 14.5243 19.9989L14.6119 19.9015L16.3146 18.2H14.1624L13.9469 18.1939C12.6603 18.1213 11.499 17.4019 10.9669 16.2852L10.8386 16.0159L10.7887 15.8948C10.5889 15.324 10.8476 14.6825 11.4065 14.4166C12.0053 14.1316 12.7218 14.3857 13.007 14.9841L13.1353 15.2533L13.1873 15.3444C13.3652 15.6097 13.7344 15.8 14.1624 15.8H16.3146L14.6119 14.0985C14.1742 13.6611 14.145 12.9701 14.5243 12.4989L14.6119 12.4015Z"
          fill="currentColor"
        />
        <path
          d="M8.15028 7.58344C8.70915 7.3175 8.9679 6.676 8.76809 6.10516L8.7182 5.98408L8.5899 5.71485C8.05774 4.5981 6.89644 3.87871 5.60982 3.80608L5.39431 3.8H1.20085C0.53764 3.8 0 4.33726 0 5C0 5.62132 0.472535 6.13235 1.07807 6.19381L1.20085 6.2H5.39431C5.82239 6.2 6.1916 6.39027 6.36947 6.65562L6.4215 6.74669L6.54979 7.01592C6.83493 7.61429 7.5515 7.86837 8.15028 7.58344Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
